import List from './List';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'approval_groups',
  inputShow: gql`
    query approvalGroups($input: ApprovalGroupQueryInput) {
      approvalGroups(input: $input) {
        id
        name
        __typename
      }
    }
  `,
  list: List,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Approval Groups',
  },
};
